const PARCELS_PMTILES_PATH = import.meta.env.VITE_PARCELS_PMTILES_PATH;
const PARCELS_FGB_PATH = import.meta.env.VITE_PARCELS_FGB_PATH;

const PARCELS_PMTILES_SOURCE_ID = "pmtiles__parcels" as const;
const PARCELS_SOURCE_LAYER = "parcels" as const;

const PARCELS_FILL_LAYER_ID = `${PARCELS_PMTILES_SOURCE_ID}__fill` as const;
const PARCELS_OUTLINE_LAYER_ID = `${PARCELS_PMTILES_SOURCE_ID}__outline` as const;
const PARCELS_EXTRUSION_LAYER_ID = `${PARCELS_PMTILES_SOURCE_ID}__extrusion` as const;
const PARCELS_LABELS_LAYER_ID = `${PARCELS_PMTILES_SOURCE_ID}__labels` as const;

export {
	PARCELS_EXTRUSION_LAYER_ID,
	PARCELS_FGB_PATH,
	PARCELS_FILL_LAYER_ID,
	PARCELS_LABELS_LAYER_ID,
	PARCELS_OUTLINE_LAYER_ID,
	PARCELS_PMTILES_PATH,
	PARCELS_PMTILES_SOURCE_ID,
	PARCELS_SOURCE_LAYER,
};
